"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _useClickSubmit = _interopRequireDefault(require("../utils/useClickSubmit"));

var _bluekeelControllers = require("@bit/bluekeel.controllers.helpers");

var _FourButtonCss = _interopRequireDefault(require("./FourButton.css.js"));

var _LoadingBubbles = _interopRequireDefault(require("../LoadingBubbles"));

var _radium = _interopRequireDefault(require("radium"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var firePixelBing = function firePixelBing(vertical) {
  try {
    window.uetq = window.uetq || [];
    window.uetq.push({
      ec: 'USC_search',
      ea: 'search',
      el: vertical || 'unknown',
      ev: .7
    });
    console.log('Bing pixel fired for vertical: ', vertical);
    return;
  } catch (e) {
    console.warn('Failed to fire Bing conversion:', e.stack);
    return;
  }
};

var ButtonGroup = function ButtonGroup(_ref) {
  var buttons = _ref.buttons,
      url = _ref.url,
      jump = _ref.jump,
      tracking = _ref.tracking,
      email = _ref.email;
  var history = (0, _reactRouterDom.useHistory)();

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      shouldExecute = _useState2[0],
      setExecute = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  (0, _useClickSubmit.default)(tracking, email, shouldExecute);

  var handleOfferClick = function handleOfferClick(keywords) {
    var linkout = (0, _bluekeelControllers.buildKeywordLink)(url, tracking, (0, _bluekeelControllers.flattenLongString)(keywords));
    var jumpBehind = (0, _bluekeelControllers.buildKeywordLink)(jump, tracking, (0, _bluekeelControllers.flattenLongString)(keywords));
    firePixelBing(tracking['vertical']);
    setLoading(true);
    setExecute(true);
    var newTab = window.open();
    newTab.location = linkout;

    if (jumpBehind && jumpBehind !== 'N/A') {
      window.location.href = jumpBehind;
    } else {
      history.push('/verticals');
    }

    ;
  };

  if (loading) {
    return /*#__PURE__*/_react.default.createElement("div", {
      style: _FourButtonCss.default.loadingContainer
    }, /*#__PURE__*/_react.default.createElement(_LoadingBubbles.default, null));
  }

  ;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: _FourButtonCss.default.buttonGroup
  }, buttons.map(function (button_text, idx) {
    return /*#__PURE__*/_react.default.createElement("button", {
      style: _objectSpread({}, _FourButtonCss.default['button'], {}, _FourButtonCss.default["button_".concat(idx)]),
      onClick: function onClick() {
        return handleOfferClick(button_text);
      },
      key: "four_button-item-".concat(idx)
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: _FourButtonCss.default.iconContainer
    }, /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: ['fal', 'angle-double-right'],
      style: _FourButtonCss.default.icon
    })), /*#__PURE__*/_react.default.createElement("div", {
      style: _FourButtonCss.default.textContainer
    }, button_text));
  }));
};

var _default = (0, _radium.default)(ButtonGroup);

exports.default = _default;

//# sourceMappingURL=ButtonGroup.jsx.map